import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import { client } from 'redux/redux'

import { CompanyInfo, MANUFACTURERS_QUERY } from 'pages/manufacturers'

import Select, { IOption } from 'components/ui/select'
import get from 'lodash/get'
import defaultTo from 'lodash/defaultTo'
import { getManufacturer, setManufacturer } from 'utils'

import { Arrow } from 'images/icons'

interface IProps {
  headline: any
  subheadline: string
  linkTo?: string
  actions?: any
  message?: string
  error?: boolean
  showManufacturerSelect?: boolean
}

const Head: React.FC<IProps> = ({
  headline,
  subheadline,
  linkTo,
  actions,
  message,
  error,
  showManufacturerSelect,
}) => {
  const transformManufacturersToOptions = (manufacturers: CompanyInfo[]) =>
    manufacturers.map((item: any) => ({
      value: String(item.id),
      label: String(item.name),
    }))

  const handleManufacturerChange = (option: IOption) => {
    setManufacturer(String(option.value))
    client.resetStore()
  }

  return (
    <div className="sticky z-50 top-0 h-100 w-full px-48 py-25 flex items-center justify-between bg-gray-100">
      <div className="flex flex-row">
        <div className="flex flex-col items-start">
          {linkTo ? (
            <Link
              style={{
                marginLeft: -8,
              }}
              className="flex items-center font-400 text-gray-400 tracking-0.32 text-12"
              to={linkTo}
            >
              <Arrow dark />
              {subheadline}
            </Link>
          ) : (
            <span className="font-400 text-gray-400 tracking-0.32 text-12">{subheadline}</span>
          )}
          <div className="w-full mt-10">
            {typeof headline === 'string' || headline instanceof String ? (
              <h1 className="h1">{headline}</h1>
            ) : (
              headline
            )}
          </div>
        </div>

        {showManufacturerSelect && (
          <div className="flex flex-col ml-25 pl-25 border-l-1 border-gray-200">
            <span
              style={{ minHeight: 24 }}
              className="flex items-center text-12 leading-14 tracking-0.32 text-gray-400 mb-10"
            >
              Hersteller
            </span>
            <Query
              query={MANUFACTURERS_QUERY}
              fetchPolicy="network-only"
              notifyOnNetworkStatusChange
            >
              {({ loading, data }: any | null) => {
                const manufacturers = get(data, 'getCompanies', [])
                const manufacturersOptions = transformManufacturersToOptions(manufacturers)

                return (
                  <Select
                    onChange={handleManufacturerChange}
                    plain
                    options={manufacturersOptions}
                    value={defaultTo(
                      manufacturersOptions.find(
                        (option: IOption) => option.value === getManufacturer(),
                      ),
                      {
                        label: 'Hersteller auswählen',
                        value: '',
                      },
                    )}
                    maxWidth={250}
                    isLoading={loading}
                  />
                )
              }}
            </Query>
          </div>
        )}
      </div>

      <div className="flex items-center">
        {message && (
          <span className={`font-400 ${error ? 'text-red' : 'text-green'} text-12 tracking-0.32`}>
            {message}
          </span>
        )}
        {actions && <div className="ml-25">{actions}</div>}
      </div>
    </div>
  )
}

export default Head
